<template lang="pug">
    div
        v-toolbar(:color="colors.primary" dark)
            actions-menu
        v-container(fluid grid-list-md)
            v-layout
                v-flex(:md8="displayDetail" :md12="!displayDetail")
                    h3 Código ticket venta:
                    search-id-venta
                    v-text-field.headline(persistent-hint outline single-line
                    label="Código ticket venta"
                    hint="Use la pistola para leer código de barra o ingrese número manualmente"
                    mask="AA##########"
                    v-model="ticketCode")
                    v-divider
                    v-fade-transition
                        payment(v-if="ticketTaken")
                v-slide-x-reverse-transition    
                    v-flex(md4 heigth="120"  v-show="items !=null" )
                        sale-detail
        snackbar-modal
        barcode-scanner-handler(@codescanned="scannerHandler($event)")
            //v-divider(vertical)
            
</template>

<script>
//Components:
import ActionsMenu from '@/components/ActionsMenu/ActionsMenu'
import SaleDetails from '@/components/CashDesk/Detail/SaleDetails'
import Payment from '@/components/CashDesk/Payment/Payment'
import SnackbarModal from '@/components/SnackbarModal/SnackbarModal'
import SearchIdVenta from '@/components/CashDesk/Detail/SearchIdVenta' //mock rosita's component only for test
import BarcodeScannerHandler from '@/components/BarcodeScannerHandler/BarcodeScannerHandler'
import { mapState} from 'vuex'


//Mixins:

export default {
    name: 'cash-desk',
    props: {},
    data: function(){
        return {
            ticketCode: "TV3456789012", // después dejar vacío
        }
    },
    computed: {
        ticketTaken(){
            return this.ticketCode.length === 12
        },
        ...mapState('CashDeskModule',{
            items : 'saleDetail'
        }),
        displayDetail:function(){
            return (this.items != null) ?  true : false
        }
    },
    methods: {
        scannerHandler(code){
            alert(code)
        }
    },
    watch: {},
    components: {
        ActionsMenu, 
        'sale-detail':SaleDetails, 
        Payment, SnackbarModal, 
        'search-id-venta': SearchIdVenta,
        'barcode-scanner-handler': BarcodeScannerHandler,
    },
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
    
</style>